/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Hide_InvoicesInputs */

const en_admin_external_booking_edit_hide_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide`)
};

const de_admin_external_booking_edit_hide_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausblenden`)
};

const es_admin_external_booking_edit_hide_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar`)
};

const fr_admin_external_booking_edit_hide_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */
const it_admin_external_booking_edit_hide_invoices = en_admin_external_booking_edit_hide_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_hide_invoices = en_admin_external_booking_edit_hide_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */
const pl_admin_external_booking_edit_hide_invoices = en_admin_external_booking_edit_hide_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */
const hu_admin_external_booking_edit_hide_invoices = en_admin_external_booking_edit_hide_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Hide_InvoicesInputs) => LocalizedString} */
const ro_admin_external_booking_edit_hide_invoices = en_admin_external_booking_edit_hide_invoices;

/**
* | output |
* | --- |
* | "Hide" |
*
* @param {Admin_External_Booking_Edit_Hide_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_hide_invoices = /** @type {((inputs?: Admin_External_Booking_Edit_Hide_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Hide_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_hide_invoices(inputs)
	if (locale === "de") return de_admin_external_booking_edit_hide_invoices(inputs)
	if (locale === "es") return es_admin_external_booking_edit_hide_invoices(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_hide_invoices(inputs)
	if (locale === "it") return it_admin_external_booking_edit_hide_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_hide_invoices(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_hide_invoices(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_hide_invoices(inputs)
	return ro_admin_external_booking_edit_hide_invoices(inputs)
});
export { admin_external_booking_edit_hide_invoices as "admin.external_booking_edit.hide_invoices" }